import { prefixRelativeUrl, isFeatureActive } from '../util.js';

$(function () {
    const $button = $('#context-dropdown-toggle');
    const $menu = $button.next('.context-dropdown');

    $('.context-menu-nav .nav-item.dropdown').on('show.bs.dropdown', (event) => {
        $('body').addClass('backdrop');
        $('.context-menu-nav .nav-item.dropdown').css('position', 'relative');
        $('.context-menu-nav .nav-item.dropdown').css('z-index', '1120');

        $menu.find('.right-panel').addClass('d-none');

        $menu.find('.context-dropdown-item.active').removeClass('active');
    });

    $('.context-menu-nav .nav-item.dropdown').on('hide.bs.dropdown', (event) => {
        $('body').removeClass('backdrop');
        $('.context-menu-nav .nav-item.dropdown').css('position', '');
        $('.context-menu-nav .nav-item.dropdown').css('z-index', '');
    });

    const populateRight = function ($target, $parent) {
        $('.left-panel .active').removeClass('active');
        $parent.addClass('active');

        const contentId = $target.data('contentid');
        const href = $parent.find('a').first().attr('href');
        const title = $parent.find('a').first().text();
        const $menu = $target.closest('.context-dropdown');

        $.getJSON(prefixRelativeUrl(`/__navigation/menuitems/${contentId}`))
            .done((data) => {
                //const headingMarkup =
                //    `<li class="context-dropdown-item border border-medium border-white"><a class="dropdown-item text-wrap font-weight-bold text-dark d-block w-100" href="${href}">${title}</a></li>`;
                const itemMarkup = data
                    .map(
                        (item) =>
                            `<li class="context-dropdown-item border border-medium border-white"><a class="dropdown-item text-wrap text-dark d-block w-100"
              href="${prefixRelativeUrl(item.Url)}" 
              data-contentid="${item.ContentId}">${item.Title}</a></li>`
                    )
                    .join('');

                $menu.find('.right-panel').removeClass('d-none');

                $menu
                    .find('.right-panel')
                    .html(
                        '<ul class="text-dark list-unstyled bg-tertiary-light">' +
                            itemMarkup +
                            '</ul>'
                    );
            })
            .done((_) => {
                $menu.find('.right-panel .context-dropdown-item a').first().focus();
            });
    };

    $menu.find('.populate-right').click((event) => {
        event.preventDefault();
        event.stopPropagation();

        var currentTarget = $(event.currentTarget);

        populateRight(currentTarget, currentTarget.parent());
    });

    $('.context-menu-nav').on('keyup', '.left-panel .dropdown-item.populate-right', (event) => {
        if (event.key === 'ArrowRight') {
            var currentTarget = $(event.currentTarget);

            populateRight(currentTarget, currentTarget.parent());
        }
    });

    $('.context-menu-nav').on('keyup', '.right-panel .dropdown-item', (event) => {
        if (event.key === 'ArrowLeft') {
            $(event.target).closest('.dropdown-menu').find('.left-panel .active a').focus();
        }
    });
});

$(function () {
    $('#context-menu .search-btn').click((event) => {
        // Timeout to compensate for when having context-menu opened and then clicking the search button
        setTimeout(() => {
            $('#context-menu .search-wrapper-lg').show();
            $(event.currentTarget).attr('aria-expanded', 'true');

            $('#context-menu .search-wrapper-lg input[type="search"]').focus();

            $('body').not('.search-page').addClass('backdrop');
        }, 10);
    });

    $('#context-menu .search-wrapper-lg button').click((event) => {
        $('#context-menu .search-wrapper-lg').hide();
        $('#context-menu .search-btn').attr('aria-expanded', 'false');
        $('body').removeClass('backdrop');
    });
});
